import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import * as toolbox from '../toolbox'

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            const response = await axios.post('https://chatwavebackend.cloudandcode.de/login', { username, password });
            if (response.status === 200) {
                toolbox.saveJWT(response.data.key);
                toolbox.saveLoginSession(username);
                navigate('/');
            }
        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                alert("Login failed");
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                alert("Internet connection failed");
            } else {
                // Something happened in setting up the request that triggered an Error
                alert("an unknown error occurred");
            }
        }
    };

    const autoFillLogin = async (name, plainPassword) => {
        setUsername(name);
        const hashed = await toolbox.generateSHA256(plainPassword);
        setPassword(hashed);   
    };

    return (
        <div>
            <div id={"loginBanner"}>
                <div>
                    <img src={process.env.PUBLIC_URL + '/speech-bubble.png'} alt={"not found"}/>
                </div>
                <span>ChatWave</span>
            </div>
            <div id={"loginFormula"}>
                <div>
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div>
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={async (e) => {
                            let hash = await toolbox.generateSHA256(e.target.value);
                            setPassword(hash)
                        }}
                        onKeyUp={(event)=>{
                            if(event.key === 'Enter'){
                                handleLogin();
                            }
                        }}
                    />
                </div>
                <div>
                    <div>
                        <img src={process.env.PUBLIC_URL + '/earth.png'} alt={"not found"}/>
                    </div>
                    <button onClick={handleLogin}>Login</button>
                </div>

            </div>
            <div id="user-prefill">
                <span>Here you can login with a standard account. Those accounts are public available. Just click on one of them and hit the "Login" button.</span>
                <button onClick={() => autoFillLogin("exampleUser", "test123")}>exampleUser</button>
                <button onClick={() => autoFillLogin("testUser", "test123")}>testUser</button>
                <button onClick={() => autoFillLogin("randomUser", "test123")}>randomUser</button>
            </div>
        </div>
    );
};

export default Login;
